module.exports = __webpack_public_path__ + "a41574bc3c2e77320d377c94971f3b03.svg";